angular.module('app').service('systemService', function ($http, $location, $q, safeApply) {

  function buildFileFormData(obj) {
    let fd = new FormData()
    fd.append('type', obj.type || '')
    fd.append('params', angular.toJson(obj.params || {}))
    fd.append('portalFile', angular.toJson(obj.portalFile || {}))
    fd.append('file', obj.file)
    return fd
  }

  this.functionCall = function (obj) {

    // If a File is provided, send multipart/form-data so the backend can receive
    // both the binary and the metadata in one request.
    if (obj && obj.file) {
      return $http.post(`/system/server/functionCall`, buildFileFormData(obj), {
        transformRequest: angular.identity,
        headers: { 'Content-Type': undefined }
      }).then(function (response) {
        return response
      })
    }

    return $http.post(`/system/server/functionCall`, obj)
      .then(function (response) {
        return response
      })
  }

  // Same multipart call as functionCall, for the upload list: onProgress(sent, total) reports the bytes sent, and
  // cancel() aborts the request (the promise then resolves with { cancelled: true }).
  this.uploadWithProgress = function (obj, onProgress) {
    let canceller = $q.defer()
    let promise = $http.post(`/system/server/functionCall`, buildFileFormData(obj), {
      transformRequest: angular.identity,
      headers: { 'Content-Type': undefined },
      timeout: canceller.promise,
      uploadEventHandlers: {
        progress: function (e) {
          if (typeof onProgress === 'function' && e && e.lengthComputable) onProgress(e.loaded, e.total)
        }
      }
    }).then(function (response) {
      return response
    }, function (response) {
      if (response && response.xhrStatus === 'abort') return { cancelled: true }
      return $q.reject(response)
    })
    return {
      promise: promise,
      cancel: function () { canceller.resolve() }
    }
  }

  this.returnToMainMenu = function (path) {
    $location.path(path)
  }

});